<template>
  <div class="full-item flex flex-direction align-center justify-center">
    <el-form
      :label-width="UI.isMobile ? undefined : '80px'"
      style="width: 90%;"
    >
      <el-form-item label="选择角色" prop="role">
        <el-select v-model="role" placeholder="暂无可以选择的角色">
          <el-option
            v-for="(role, index) in roles"
            :key="index"
            :label="role.label"
            :value="role.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-button
      class="padding-xs margin-top"
      type="primary"
      style="width: 200px;"
      size="mini"
      :disabled="!roles || !roles.length"
      @click="submit()"
    >
      提交
    </el-button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { roleConsts } from '@/utils/consts';
import { addRole } from '@/servers/user';
import { showErrorMsg } from '@/utils/uiUtils.js';

export default {
  computed: {
    ...mapState(['User', 'UI']),
  },

  data() {
    return {
      role: '',
      roles: [],
    };
  },

  mounted() {
    let defaultRoles = [roleConsts.PLAYER, roleConsts.TECH_OFFICER];
    for (let role of defaultRoles) {
      if (role.value != this.User.user.role) {
        if (
          role.value == roleConsts.PLAYER.value &&
          this.User.user.role == roleConsts.ORG_PLAYER.value
        ) {
          continue;
        } else if (
          role.value == roleConsts.ORG_PLAYER.value &&
          this.User.user.role == roleConsts.PLAYER.value
        ) {
          continue;
        } else {
          this.roles.push(role);
        }
      }
    }
    if (this.roles && this.roles.length) {
      this.role = this.roles[0].value;
    }
  },

  methods: {
    submit() {
      if (this.role) {
        let that = this;
        addRole(this.role, function() {
          that.$router.replace({
            path: '/login',
          });
        });
      } else {
        showErrorMsg('请选择role.');
      }
    },
  },
};
</script>
<style scoped>
.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/role/roleEdit.vue